// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"aa56f478","455":"ba0306d1","977":"240addac"}[chunkId] + ".chunk.js";
};